import React from "react";

const InfluencerCreatorsMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src="https://www.sunrisingcinevisionacademy.com/public/assets/images/influencer-creators.jpg" alt="Influencer Creators" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Become a Successful Influencer with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy offers a comprehensive Influencer Creators course designed to help you build a powerful digital presence. Learn the secrets of content creation, personal branding, and audience engagement from industry leaders. Whether you want to be a lifestyle, travel, or niche influencer, this course equips you with the skills and strategies to grow and monetize your online influence.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Content creation for Instagram, YouTube, and emerging platforms</li>
              <li>Personal branding and storytelling techniques</li>
              <li>Audience growth, engagement, and analytics</li>
              <li>Collaboration, networking, and influencer marketing</li>
              <li>Monetization strategies and brand partnerships</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Foundational Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Introduction to Influencer Marketing</li>
              <li>Understanding Social Media Platforms</li>
              <li>Personal Branding Essentials</li>
              <li>Content Planning & Strategy</li>
              <li>Visual Storytelling Basics</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Intermediate Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Video Production & Editing</li>
              <li>Photography for Social Media</li>
              <li>Copywriting & Caption Crafting</li>
              <li>Audience Engagement & Community Building</li>
              <li>Analytics & Growth Hacking</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Advanced Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Brand Collaborations & Sponsorships</li>
              <li>Influencer Campaign Management</li>
              <li>Legal & Ethical Aspects</li>
              <li>Monetization & Revenue Streams</li>
              <li>Scaling Your Influence</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Specialized Workshops:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Reels & Shorts Mastery</li>
              <li>Podcasting for Influencers</li>
              <li>Live Streaming Techniques</li>
              <li>Building a Personal Website</li>
              <li>PR & Media Relations</li>
            </ol>
          </div>
        </div>

        {/* Instructors & More */}
        <div className="p-10 mt-10 bg-white shadow-md rounded-xl">
          <h2 className="text-3xl font-bold text-center mb-10 text-[#A14D1F]">Learn from Top Influencers & Industry Experts</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Influencer Mentors:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Kusha Kapila</li>
                <li>Ranveer Allahbadia (BeerBiceps)</li>
                <li>Sejal Kumar</li>
                <li>Prajakta Koli (MostlySane)</li>
                <li>Tech Burner</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Digital Marketing Experts:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Industry Social Media Strategists</li>
                <li>Brand Managers</li>
                <li>Content Marketing Professionals</li>
                <li>SEO & Analytics Specialists</li>
                <li>PR Consultants</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Guest Speakers:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Leading YouTubers & Instagrammers</li>
                <li>Brand Collaboration Managers</li>
                <li>Legal Advisors for Influencers</li>
                <li>Successful Alumni Influencers</li>
                <li>Media Personalities</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Partnerships, Alumni, Certifications, Scholarships, Duration, Outcomes */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Industry Partnerships</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Meta (Facebook & Instagram)</li>
              <li>YouTube Creators India</li>
              <li>Influencer Marketing Agencies</li>
              <li>Popular Indian Brands</li>
              <li>Content Production Studios</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Alumni Network</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Connect with successful digital creators and influencers.</li>
              <li>Mentorship and collaboration opportunities.</li>
              <li>Access to exclusive brand campaigns.</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certifications Offered</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certificate in Influencer Creation</li>
              <li>Advanced Certificate in Digital Branding</li>
              <li>Specialization in Social Media Strategy</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Scholarship Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Merit-based scholarships</li>
              <li>Need-based scholarships</li>
              <li>Women in Digital Leadership scholarships</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Course Duration</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certificate Course – 3 months</li>
              <li>Advanced Certificate – 6 months</li>
              <li>Specialization Program – 9 months</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Key Learning Outcomes</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Build and grow your personal brand online.</li>
              <li>Create engaging content for multiple platforms.</li>
              <li>Develop strategies for audience growth and engagement.</li>
              <li>Collaborate with brands and monetize your influence.</li>
              <li>Gain hands-on experience with expert mentorship and real-world projects.</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Start Your Influencer Journey Today!</h3>
          <p className="mb-6 text-gray-700">Enroll in the Influencer Creators course at Sunrising Cinevision Academy and take your first step toward becoming a digital star.</p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default InfluencerCreatorsMain;
